import React from 'react';
import Paper from '@mui/material/Paper';
import Filter from './Filter';
import ReportFilterTags from '../common/ReportFilterTags';
import ReportDownloadButton from '../common/ReportDownloadButton';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  remCalc,
  translate,
} from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';

const t = (key: string, options?) => translate('reports', key, options);

const ClassroomReportHeader: React.FC = () => {
  const classes = useStyles();

  return (
    <Box
      component={Paper}
      padding={6}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gap={'1rem'}
      className="noPrint"
    >
      <Box>
        <Typography variant="h1" className={classes.headerTitle}>
          {t('viewStudentProgressFor')}
        </Typography>
        <Typography variant="subtitle1" component="summary" className={classes.headerSummary}>
          {t('reportSelectHelp')}
        </Typography>
        <Filter />
        <Box className={classes.filterTags}>
          <ReportFilterTags />
        </Box>
      </Box>
      <Box>
        <ReportDownloadButton />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  headerTitle: {
    fontSize: remCalc(16),
    lineHeight: remCalc(25),
    marginBottom: remCalc(8),
  },
  headerSummary: {
    fontSize: remCalc(14),
    lineHeight: remCalc(20),
    marginBottom: remCalc(8),
  },
  filterTags: {
    marginTop: remCalc(30),
  },
}));

export default ClassroomReportHeader;
